import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { listClass } from './styles';

var Extra =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Extra, _PureComponent);

  var _super = _createSuper2(Extra);

  function Extra() {
    _classCallCheck(this, Extra);

    return _super.apply(this, arguments);
  }

  _createClass(Extra, [{
    key: "render",
    value: function render() {
      var _this = this;

      var render = this.props.extra.map(function (value, index) {
        return (
          /*#__PURE__*/
          React.createElement(React.Fragment, {
            key: index
          }, value, index < _this.props.extra.length - 1 ?
          /*#__PURE__*/
          React.createElement("div", {
            className: listClass('split')
          }) : null)
        );
      });
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: listClass('extra')
        }, render)
      );
    }
  }]);

  return Extra;
}(PureComponent);

export default Extra;